import React from "react";
import { Shift } from "../../util/types";

interface ShiftCardProps {
  shift: Shift;
  onViewAgents: (shift: Shift) => void;
}

const ShiftCard: React.FC<ShiftCardProps> = ({ shift, onViewAgents }) => {
  return (
    <div
      onClick={() => onViewAgents(shift)}
      className="border rounded-lg p-2 transition-all duration-300 cursor-pointer hover:shadow-lg hover:border-indigo-300 dark:hover:border-indigo-500 bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600"
    >
      <div className="flex items-start justify-between mb-1">
        <div className="font-semibold text-gray-700 dark:text-gray-200 text-sm">
          {shift.shiftName}
        </div>
        {shift.onlyMale && (
          <span className="inline-block px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 text-xs rounded ml-1 flex-shrink-0">
            MALE
          </span>
        )}
        {shift.onlyFemale && (
          <span className="inline-block px-1.5 py-0.5 bg-pink-100 dark:bg-pink-900/50 text-pink-700 dark:text-pink-300 text-xs rounded ml-1 flex-shrink-0">
            FEMALE
          </span>
        )}
        {shift.bothGenderAllowed && (
          <span className="inline-block px-1.5 py-0.5 bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300 text-xs rounded ml-1 flex-shrink-0">
            BOTH GENDERS
          </span>
        )}
      </div>
      <div className="text-xs text-gray-500 dark:text-gray-400 mb-1.5">
        {shift.startHour}:00 - {shift.endHour}:00
      </div>

      <div
        className={`flex items-center justify-between text-xs ${
          shift.assignedAgents.length < shift.requiredAgents 
            ? "text-red-600 dark:text-red-400" 
            : "text-green-600 dark:text-green-400"
        }`}
      >
        <span>
          Agents: {shift.assignedAgents.length} / {shift.requiredAgents}
        </span>
        <span className="font-semibold text-indigo-600 dark:text-indigo-400 opacity-75 group-hover:opacity-100">
          View &rarr;
        </span>
      </div>
    </div>
  );
};

export default ShiftCard;
